import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BestOddsRoutingModule } from './best-odds-routing.module';
import { BestOddsComponent } from './best-odds/best-odds.component';
import { GeneralModule } from '../general/general.module';


@NgModule({
  declarations: [BestOddsComponent],
  imports: [
	CommonModule,
	BestOddsRoutingModule,
  GeneralModule
  ]
})
export class BestOddsModule { }
